<template>
  <div>
    
    <div style="margin-top: 50px; display: flex; flex-direction: column; justify-content: center; align-items: center;">
        <div 
            style="margin-top: 50px; display: flex; 
            flex-direction: column; 
            width: 400px; 
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); 
            padding: 20px;
            justify-content: center; align-items: center;">

                <div style="margin-top: 20px; display: flex; flex-direction: column; width: 80%;  justify-content: flex-start; align-items: flex-start;">
                    <span type="label">Current Password</span>
                    <el-input @focus="$event.target.select()"
                        id="current_password"
                        type="password"
                        show-password
                        v-model.trim="current_password">
                    </el-input>
                </div>
                <div style="margin-top: 20px; display: flex; flex-direction: column; width: 80%;  justify-content: flex-start; align-items: flex-start;">
                    <span type="label">New Password</span>
                    <el-input @focus="$event.target.select()"
                        id="new_password"
                        type="password"
                        show-password
                        v-model.trim="new_password">
                    </el-input>
                </div>

                <div style="margin-top: 20px; display: flex; flex-direction: column; width: 80%;  justify-content: flex-start; align-items: flex-start;">
                    <span type="label">Confirm Password</span>
                    <el-input @focus="$event.target.select()"
                        id="loginPassword"
                        type="password"
                        show-password
                        v-model.trim="confirm_password">
                    </el-input>
                </div>
                <div style="margin-top: 20px; display: flex; flex-direction: row; width: 80%;  justify-content: space-between; align-items: space-between;">
                    <el-button :loading="$store.getters.getLoadingState" @click="changePassword" type="primary" size="small">Change Password</el-button>
                </div>

        </div>
    </div>
        
  </div>
</template>

<script>
export default {
    data() {
        return {
            current_password: '',
            new_password: '',
            confirm_password: '',
            processing: false
        }
    },
    computed: {
        isProcessing() {
            return this.processing
        }
    },
    methods: {
        changePassword() {
            
            if(this.current_password.length === 0) {
                this.$store.commit('displayMessageAlert', {message: 'Current password is wrong/missing!!!', type: 'Error'})    
                document.getElementById('current_password').focus()
                return
            } else if(this.new_password.length === 0) {
                this.$store.commit('displayMessageAlert', {message: 'New password is missing!!!', type: 'Error'})    
                document.getElementById('new_password').focus()
                return
            } else if(this.confirm_password.length === 0) {
                this.$store.commit('displayMessageAlert', {message: 'Confirm password is missing!!!', type: 'Error'})    
                document.getElementById('confirm_password').focus()
                return
            } else if(this.new_password !== this.confirm_password) {
                this.$store.commit('displayMessageAlert', {message: 'New and confirm password do not match!!!', type: 'Error'})    
                document.getElementById('new_password').focus()
                return
            }

            this.$store.dispatch('changePassword', {
                current_password: this.current_password,
                new_password: this.new_password,
                confirm_password: this.confirm_password
            })

        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Session/ChangePassword.vue